import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Company } from "src/app/ui/models/domains/pbm/companies/company";
import { UserService } from "src/app/ui/services/user.service";
import { CompanyFilterDialogComponent } from "../dialogs/company-filter-dialog/company-filter-dialog.component";
import { MatDialogRef, MatDialog } from "@angular/material/dialog";

@Component({
  selector: "indicator-filter",
  templateUrl: "./indicator-filter.component.html",
  styleUrls: ["./indicator-filter.component.scss"],
})
export class IndicatorFilterComponent {
  @Output() private filterDataEvent = new EventEmitter<Company>();
  @Input() private companyName: string;
  @Input() private indicatorName: string;

  private companyFilterDialogRef: MatDialogRef<CompanyFilterDialogComponent>;
  private filterValue: string;

  constructor(private dialog: MatDialog, private userService: UserService) {}

  ngOnInit(): void {
    const user = this.userService.getUserProfile().getUser();

    if (this.companyName) {
      this.filterValue = this.companyName;
    } else {
      this.filterValue = "TODAS AS EMPRESAS";
    }
  }

  public getFilterValue(): string {
    return this.filterValue;
  }

  public openCompanyFilterDialog() {
    let indicatorName: string;

    if (this.indicatorName) {
      indicatorName = this.indicatorName;
    }

    this.companyFilterDialogRef = this.dialog.open(CompanyFilterDialogComponent, {
      disableClose: true,
      hasBackdrop: true,
      height: "500px",
      width: "800px",
      data: indicatorName,
    });

    this.companyFilterDialogRef.componentInstance.applyFilterEvent.subscribe((company: Company) => {
      if (company) {
        this.filterValue = company.getTradingName();
      } else {
        this.filterValue = "TODAS AS EMPRESAS";
      }
      this.filterDataEvent.emit(company);
    });
  }

  public clearFilter() {
    this.filterValue = "TODAS AS EMPRESAS";
    this.filterDataEvent.emit(null);
  }
}
